/** MIRACO 2 KS 业务交互（Google / OpenAI 追踪见 snippets/ks-miraco2--google-tracking.liquid） */
const KS_MIRACO2_GG_SIGNUP_PATH = '/pages/miraco2-signup-gg'
const KS_MIRACO2_CHATGPT_SIGNUP_PATH = 'miraco2-signup-chatgpt'
const KS_MIRACO2_SIGNUP_ANCHOR = '#ks-sign'

function ksMiraco2IsGgSignupPage() {
  return window.location.pathname.includes(KS_MIRACO2_GG_SIGNUP_PATH)
}

function ksMiraco2IsChatgptSignupPage() {
  return (
    document.documentElement.dataset.ksMiraco2OpenaiPixel === '1' &&
    window.location.pathname.includes(KS_MIRACO2_CHATGPT_SIGNUP_PATH)
  )
}

function ksMiraco2OpenaiMeasureRegistrationCompleted() {
  if (typeof window.oaiq !== 'function') return
  window.oaiq('measure', 'registration_completed', { type: 'customer_action' })
}

function ksMiraco2Boot() {
  bannerOffIcon()
  ksMiraco2ScrollTopInit()
  ksMiraco2FixedInit()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ksMiraco2Boot)
} else {
  ksMiraco2Boot()
}

/** 预热页左侧 fixed：#ks-sign 滚过参考线后显示 */
function ksMiraco2FixedInit() {
  const fixed = document.querySelector('[data-ks-miraco2-fixed]')
  if (!fixed || fixed.dataset.ksMiraco2FixedBound === '1') return
  fixed.dataset.ksMiraco2FixedBound = '1'

  let pinTimer = null

  const hideFixed = () => {
    fixed.hidden = true
    fixed.classList.add('is-hidden')
  }

  const showFixed = () => {
    fixed.style.top = ''
    fixed.hidden = false
    fixed.classList.remove('is-hidden')
  }

  const getSignupScrollTarget = () => document.getElementById('ks-sign')

  const getFixedReferenceTop = () => {
    const inlineTop = fixed.style.top
    if (inlineTop && inlineTop.endsWith('px')) {
      return parseFloat(inlineTop, 10)
    }
    return window.innerHeight * 0.35
  }

  const isPastKsSignAnchor = () => {
    const sign = getSignupScrollTarget()
    if (!sign) return false
    const signBottom = sign.getBoundingClientRect().bottom
    return signBottom <= getFixedReferenceTop()
  }

  const syncFixedVisibility = () => {
    if (window.innerWidth <= 768) {
      hideFixed()
      return
    }
    if (isPastKsSignAnchor()) showFixed()
    else hideFixed()
  }

  const scrollToSignupSection = () => {
    const target = getSignupScrollTarget()
    if (!target) return

    if (typeof jumpToTarget === 'function') {
      try {
        jumpToTarget(KS_MIRACO2_SIGNUP_ANCHOR)
        return
      } catch (error) {
        console.warn('ks-miraco2-fixed: jumpToTarget failed', error)
      }
    }

    const countrySelectContainer = document.querySelector('#countrySelectContainer')
    const stickyNav = document.querySelector('.xmmune')
    const breadnavSticky = document.querySelector('.section-breadnav-sticky__inner')
    const countryContainerH = countrySelectContainer?.getBoundingClientRect()?.height || 0
    const stickyNavH = stickyNav?.getBoundingClientRect()?.height || 0
    const breadnavStickyH = breadnavSticky?.getBoundingClientRect()?.height || 0
    const headerOffset = 65 + stickyNavH + countryContainerH + breadnavStickyH
    const top = target.getBoundingClientRect().top + window.scrollY - headerOffset

    window.scrollTo({ top, behavior: 'smooth' })
  }

  fixed.addEventListener('mouseenter', () => {
    fixed.classList.add('is-pinned')
    if (pinTimer) window.clearTimeout(pinTimer)
  })

  fixed.addEventListener('mouseleave', () => {
    pinTimer = window.setTimeout(() => {
      fixed.classList.remove('is-pinned')
    }, 120)
  })

  fixed.addEventListener('click', event => {
    const signup = event.target.closest('[data-ks-miraco2-fixed-signup]')
    if (!signup) return

    event.preventDefault()
    event.stopPropagation()
    scrollToSignupSection()
    window.setTimeout(syncFixedVisibility, 400)
    window.setTimeout(syncFixedVisibility, 800)
  })

  window.addEventListener('scroll', syncFixedVisibility, { passive: true })
  window.addEventListener('resize', syncFixedVisibility, { passive: true })
  syncFixedVisibility()
}

/** 购买页 VIP CTA：回到页面顶部（主商品区） */
function ksMiraco2ScrollTopInit() {
  if (document.documentElement.dataset.ksMiraco2ScrollTopBound === '1') return
  document.documentElement.dataset.ksMiraco2ScrollTopBound = '1'

  document.addEventListener('click', event => {
    const btn = event.target.closest('[data-ks-miraco2-scroll-top]')
    if (!btn) return

    event.preventDefault()

    const mainSection =
      document.querySelector('.shopify-section[id*="__main"]') ||
      document.getElementById('main-content') ||
      document.querySelector('main')

    if (mainSection) {
      mainSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
      return
    }

    window.scrollTo({ top: 0, behavior: 'smooth' })
  })
}

function bannerOffIcon() {
  const bannerEl = document.querySelector('.section-range-banner-container')
  if (!bannerEl || bannerEl.querySelector('.ks-miraco2-banner-off-icon')) return

  const imgIcon = document.createElement('img')
  imgIcon.src =
    'https://cdn.shopify.com/s/files/1/0538/9533/2027/files/pop4-banner-off-30.png?v=1775130708'
  imgIcon.alt = 'pop4-ks-icon'
  imgIcon.classList.add('ks-miraco2-banner-off-icon')
  bannerEl.appendChild(imgIcon)
}

document.addEventListener('globo.formbuilder.form.submitted', () => {
  if (ksMiraco2IsChatgptSignupPage()) {
    try {
      ksMiraco2OpenaiMeasureRegistrationCompleted()
    } catch (error) {
      console.warn('ks-miraco2: OpenAI registration_completed failed', error)
    }
  }

  if (!ksMiraco2IsGgSignupPage()) return
  if (typeof window.gtag_report_conversion !== 'function') return

  try {
    window.gtag_report_conversion()
  } catch (error) {
    console.warn('ks-miraco2: signup conversion failed', error)
  }
})

document.addEventListener(
  'click',
  event => {
    if (!ksMiraco2IsGgSignupPage()) return

    const trackEl = event.target.closest('[data-ks-miraco2-gg-signup-conversion]')
    if (!trackEl) return

    const href = trackEl.getAttribute('href')
    if (typeof window.gtag_report_conversion !== 'function') return

    if (href && trackEl.tagName === 'A') {
      event.preventDefault()
      window.gtag_report_conversion(href)
    } else {
      window.gtag_report_conversion()
    }
  },
  true
)
